import { LoadManager } from 'managers/LoadManager'

const name = 'LOAD-SPLASH'

async function execute() {
  return LoadManager.splash()
}

export function getLoadSplashAction() {
  return {
    name,
    execute,
  }
}
